var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomToFitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.666 29.3333V26.6666H26.666V22.6666H29.3327V27.3333C29.3327 27.8533 29.1194 28.32 28.7194 28.72C28.3194 29.12 27.8527 29.3333 27.3327 29.3333H22.666ZM9.33268 29.3333H4.66602C4.14602 29.3333 3.67935 29.12 3.27935 28.72C2.87935 28.32 2.66602 27.8533 2.66602 27.3333V22.6666H5.33268V26.6666H9.33268V29.3333ZM22.666 2.66663H27.3327C27.8527 2.66663 28.3194 2.87996 28.7194 3.27996C29.1194 3.67996 29.3327 4.14663 29.3327 4.66663V9.33329H26.666V5.33329H22.666V2.66663ZM9.33268 2.66663V5.33329H5.33268V9.33329H2.66602V4.66663C2.66602 4.14663 2.87935 3.67996 3.27935 3.27996C3.67935 2.87996 4.14602 2.66663 4.66602 2.66663H9.33268ZM13.9993 7.99996C17.3327 7.99996 19.9993 10.6666 19.9993 14C19.9993 15.1733 19.666 16.2666 19.0793 17.2L23.426 21.5466L21.546 23.4266L17.1993 19.08C16.266 19.6666 15.1727 20 13.9993 20C10.666 20 7.99935 17.3333 7.99935 14C7.99935 10.6666 10.666 7.99996 13.9993 7.99996ZM13.9993 10.6666C12.1593 10.6666 10.666 12.16 10.666 14C10.666 15.84 12.1593 17.3333 13.9993 17.3333C15.8393 17.3333 17.3327 15.84 17.3327 14C17.3327 12.16 15.8393 10.6666 13.9993 10.6666Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomToFitIcon);
export default __webpack_public_path__ + "static/media/zoom-to-fit-icon.f7d5f39d7b9e1c8925c205d74f002af5.svg";
export { ForwardRef as ReactComponent };